<template>
    <svg
        class="contact-popup__close-icon"
        width="24"
        height="24"
        viewBox="0 0 18 18"
        aria-hidden="true"
        focusable="false"
    >
        <path
            fill="currentColor"
            d="M17.1880614,0.000222795923 C16.9786099,0.0051691383 16.7796225,0.0927831659 16.6345452,0.243935565 L8.99994552,7.87854774 L1.3653458,0.243935565 C1.21599022,0.0901265476 1.01073206,0.00332940419 0.796339368,0.00332085281 C0.473471873,0.00339962507 0.182872515,0.199175623 0.0615168921,0.49836876 C-0.0598387311,0.797561896 0.0122706201,1.14045653 0.243855809,1.3654274 L7.87845542,9.00003968 L0.243855809,16.6346519 C0.036673275,16.8335759 -0.0467828765,17.1289626 0.0256729498,17.4068936 C0.0981287761,17.6848246 0.315174803,17.901871 0.59310533,17.974327 C0.871035856,18.046783 1.16642211,17.9633267 1.3653458,17.7561438 L8.99994552,10.1215316 L16.6345452,17.7561438 C16.833469,17.9633259 17.1288549,18.0467816 17.406785,17.9743255 C17.684715,17.9018695 17.9017607,17.6848235 17.9742166,17.406893 C18.0466726,17.1289624 17.963217,16.8335761 17.7560353,16.6346519 L10.1214356,9.00003968 L17.7560353,1.3654274 C17.9920916,1.13886122 18.064804,0.790596215 17.9391231,0.488504687 C17.8134422,0.186413159 17.5151622,-0.00750529207 17.1880614,0.000222795923 Z"
        />
    </svg>
</template>

<script>
export default {
    name: "CloseIcon",
};
</script>
